// Public surface of the Learn Phoebe slice: the page the route mounts, the
// sidebar checklist, and the pieces the chat composer's inline hints reuse —
// the scripted fake-chat demo plus the lesson prompt content. Everything else
// stays internal.
//
// GetStartedChecklist is deliberately mounted nowhere right now. It was pulled
// out of the sidebar footer because it was not earning its place: 13 of 1,973
// members ever finished all five steps, and every member stuck at four was
// missing the same click-only step. The component, its API route, and the
// derived completion state on OrgMemberProfile all stay so a future onboarding
// surface can pick them back up without a rebuild.
export {
    LEARN_TASKS,
    promptPlainText,
    type SlottedPrompt,
} from '@apps/web/features/learn_phoebe/model/learn_content';
export { FakeChat } from '@apps/web/features/learn_phoebe/ui/fake_chat';
export { GetStartedChecklist } from '@apps/web/features/learn_phoebe/ui/get_started_checklist';
export { LearnPhoebePage } from '@apps/web/features/learn_phoebe/ui/learn_phoebe_page';
